// Popup Error Handler for Firebase Auth
// Suppresses COOP-related console errors that don't affect functionality

export function initializePopupErrorHandler() {
  // Store original console methods
  const originalConsoleError = console.error;
  const originalConsoleWarn = console.warn;
  
  // Filter out COOP-related errors that are expected behavior
  console.error = function(...args) {
    const errorString = args.join(' ');
    
    // Skip COOP-related errors from Firebase Auth popup handling
    if (errorString.includes('Cross-Origin-Opener-Policy') && 
        (errorString.includes('window.closed') || errorString.includes('window.close'))) {
      // These errors are expected when using Firebase Auth with COOP headers
      // The authentication still works correctly despite these console errors
      return;
    }
    
    // Skip service worker POST caching errors (in case any slip through)
    if (errorString.includes('Failed to execute \'put\' on \'Cache\'') && 
        errorString.includes('Request method \'POST\' is unsupported')) {
      return;
    }
    
    // Call original console.error for all other errors
    originalConsoleError.apply(console, args);
  };
  
  console.warn = function(...args) {
    const warnString = args.join(' ');
    
    // Skip COOP-related warnings
    if (warnString.includes('Cross-Origin-Opener-Policy')) {
      return;
    }
    
    originalConsoleWarn.apply(console, args);
  };
  
  // Also add a global error handler for uncaught COOP errors
  window.addEventListener('error', (event) => {
    if (event.message && event.message.includes('Cross-Origin-Opener-Policy')) {
      event.preventDefault();
      return;
    }
  });
  
  // Return cleanup function
  return () => {
    console.error = originalConsoleError;
    console.warn = originalConsoleWarn;
  };
}

// Alternative approach: Use signInWithRedirect instead of signInWithPopup
// This avoids COOP issues entirely but changes the UX
export function recommendAlternativeAuth() {
  return {
    message: "Consider using signInWithRedirect instead of signInWithPopup to avoid COOP issues",
    implementation: `
      // Instead of:
      // await signInWithPopup(auth, provider);
      
      // Use:
      // await signInWithRedirect(auth, provider);
      // 
      // Then handle redirect result on page load:
      // const result = await getRedirectResult(auth);
    `
  };
}